import { render, staticRenderFns } from "./wrapperItemComertialReport.vue?vue&type=template&id=5f702fc2&scoped=true"
import script from "./wrapperItemComertialReport.vue?vue&type=script&lang=js"
export * from "./wrapperItemComertialReport.vue?vue&type=script&lang=js"
import style0 from "./wrapperItemComertialReport.vue?vue&type=style&index=0&id=5f702fc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f702fc2",
  null
  
)

export default component.exports